import { Controller } from "@hotwired/stimulus"

// Precificação assistida ao vivo: custo + peso × frete/lb + margem → US$ e R$.
// Espelha o PriceCalculator do backend (mesma fórmula).
export default class extends Controller {
  static targets = ["cost", "weight", "margin", "priceUsd", "priceBrl", "freight", "base", "manualUsd", "manualBrl"]
  static values = {
    rate: Number,
    freightPerLb: Number,
    defaultMargin: Number
  }

  connect() {
    this.recalc()
  }

  recalc() {
    const cost = this.num(this.hasCostTarget ? this.costTarget.value : 0)
    const weight = this.num(this.hasWeightTarget ? this.weightTarget.value : 0)
    const margin = this.hasMarginTarget && this.marginTarget.value !== ""
      ? this.num(this.marginTarget.value)
      : this.defaultMarginValue

    const freight = weight * this.freightPerLbValue
    const base = cost + freight
    const priceUsd = base * (1 + margin / 100)
    const priceBrl = priceUsd * this.rateValue

    if (this.hasFreightTarget) this.freightTarget.textContent = this.usd(freight)
    if (this.hasBaseTarget) this.baseTarget.textContent = this.usd(base)
    if (this.hasPriceUsdTarget) this.priceUsdTarget.textContent = this.usd(priceUsd)
    if (this.hasPriceBrlTarget) this.priceBrlTarget.textContent = this.brl(priceBrl)

    // Só sugere no campo de preço manual se estiver vazio (não sobrescreve edição).
    if (this.hasManualUsdTarget && this.manualUsdTarget.dataset.touched !== "true" && cost > 0) {
      this.manualUsdTarget.value = priceUsd > 0 ? priceUsd.toFixed(2) : ""
    }
  }

  touchManual(event) {
    event.currentTarget.dataset.touched = "true"
  }

  num(v) {
    if (v === null || v === undefined) return 0
    const n = parseFloat(String(v).replace(",", "."))
    return isNaN(n) ? 0 : n
  }

  usd(v) {
    return "US$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  brl(v) {
    return "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
}
